
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/restaurant/[slug]",
      function () {
        return require("private-next-pages/restaurant/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/restaurant/[slug]"])
      });
    }
  